import Cache from "../../utils/Cache";

export class Quiz {
  constructor(el) {
    Object.assign(this, {
      el: el,
      timeAllowed: el.dataset.timeAllowed,
      quizHash: el.querySelector("#quiz_hash").value,
      elStart: el.querySelector("[data-start]"),
      elCheckLegal: el.querySelector("[data-check-legal]"),
      elSubmitBtn: el.querySelector("[data-submit-button]"),
      elQuizNav: el.querySelector("[data-quiz-nav]"),
      elTime: el.querySelector("[data-time]"),
      elNavToggles: el.querySelectorAll("[data-side-toggle]"),
      elAccessibilityBtn: el.querySelector("[data-side-accessibility]"),
    });

    if (this.elTime) {
      this.init();
    }
  }

  init() {
    this.remaining = this.timeAllowed;
    this.render(this.remaining);

    //this.el.classList.add("has-started");
    this.start(this.remaining);

    // on submit
    this.el.addEventListener("submit", () => {
      this.elSubmitBtn.disabled = true;
      this.el.disabled = true;
      this.pause();
    });

    this.initSidePanels();
    this.initChoicesInteraction();
    this.initAccessibility();
  }

  start(seconds) {
    // We check if allowed time under 3 hours, we show the timer, else, we wait until then.
    if (this.remaining < 3 * 3600) {
      document.documentElement.classList.add("has-started");
    }
    const initialTime = new Date();

    // If the interval doesn't exist yet
    if (!this.interval) {
      this.interval = setInterval(() => {
        const newTime = new Date();
        const dateDiff = new Date(newTime - initialTime);
        let secondsPassed = dateDiff.getTime() / 1000;

        if (secondsPassed > 0) {
          this.remaining = seconds - secondsPassed;
          this.render(this.remaining);
          if (this.remaining < 1) {
            this.onEnd();
          } else if (this.remaining < 3600 * 3) {
            document.documentElement.classList.add("has-started");
          }
        }
      }, 100);
    } else {
      this.clear();
    }
  }

  pause() {
    clearInterval(this.interval);
  }

  clear() {
    clearInterval(this.interval);
    this.inverval = null;
  }

  formatMinToSec(seconds) {
    const minutes = Math.floor(seconds / 60);
    const secs = Math.floor(seconds - minutes * 60);

    return `${minutes}:${this.pad(secs)}`;
  }

  render(seconds) {
    const strCount = this.formatMinToSec(seconds);
    this.elTime.innerText = strCount;

    // Theme change
    if (seconds <= 60) {
      this.el.setAttribute("data-theme", "urgent");
    } else if (seconds <= 60 * 5) {
      this.el.setAttribute("data-theme", "warning");
    }
  }

  onEnd(e) {
    this.clear();
    this.el.querySelector("[data-timeout]").value = 1;
    this.el.submit();
  }

  pad(num) {
    return num < 10 ? `0${num}` : num;
  }

  initChoicesInteraction() {
    const questions = this.el.querySelectorAll(".js-question");
    for (let i = 0; i < questions.length; i++) {
      const question = questions[i];
      const id = question.id.substr(1, question.id.length);

      // Mini nav
      const inputs = question.querySelectorAll(".input__element");
      Array.from(inputs).forEach((input) => {
        if (input.type == "radio" && input.checked) {
          this.activateMenuItem(id, question);
        } else if (input.type == "text" && !!input.value.length) {
          this.activateMenuItem(id, question);
        }

        input.addEventListener("input", this.inputChange.bind(this));
      });

      // Clear
      const clearBtn = question.querySelector(".js-clear");
      if (clearBtn) {
        clearBtn.addEventListener("click", (e) => {
          for (let i = 0; i < inputs.length; i++) {
            const input = inputs[i];
            input.checked = false;
          }
          this.deactivateMenuItem(id, question);
        });
      }
    }
  }

  initSidePanels() {
    Array.from(this.elNavToggles).forEach((element) => {
      element.addEventListener("click", (e) => {
        e.currentTarget.parentNode.classList.toggle("is-active");
      });
    });
  }

  activateMenuItem(id, questionContainer) {
    const navEl = this.elQuizNav.querySelector(`[href="#q${id}"`);
    if (navEl) {
      navEl.classList.add("is-disabled");
    }

    if (questionContainer) {
      questionContainer.classList.add("has-selection");
    }
  }

  deactivateMenuItem(id, questionContainer) {
    const navEl = this.elQuizNav.querySelector(`[href="#q${id}"`);
    if (navEl) {
      navEl.classList.remove("is-disabled");
    }

    if (questionContainer) {
      questionContainer.classList.remove("has-selection");
    }
  }

  inputChange(e) {
    const target = e.target;
    const id = target.id.split("_")[1];
    const container = target.closest(".js-question");

    if (target.type == "radio" && target.checked) {
      this.activateMenuItem(id, container);
    } else if (target.type == "text" && !!target.value.length) {
      this.activateMenuItem(id, container);
    } else {
      this.deactivateMenuItem(id, container);
    }
  }

  initAccessibility() {
    this.elAccessibilityBtn.addEventListener("click", (e) => {
      document.documentElement.classList.toggle("has-accessible-text");
    });
  }
}
